module.exports = __webpack_public_path__ + "static/img/null-store-icon_dark.e17f4ca2.png";